import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '企业',
      placeholder: '不限',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'account',
      type: 'input',
      label: '交接账号',
      placeholder: '交接账号的ID'
    },
    {
      field: 'phone',
      type: 'input',
      label: '绑定手机号',
      placeholder: '账号绑定的手机号码'
    },
    {
      field: 'fromUserName',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'toUserName',
      type: 'select',
      label: '承接人',
      filterable: true,
      clearable: true,
      placeholder: '请选择承接人'
    },
    {
      field: 'finishTime',
      type: 'datepicker',
      label: '审批日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
